import * as log from "loglevel";

let galleries = Array.from(document.querySelectorAll(".image-gallery")),
    indicators = Array.from(document.querySelectorAll(".image-gallery .indicator")),
    allButtons = Array.from(document.querySelectorAll(".image-gallery .image-strip button")),
    arrows = Array.from(document.querySelectorAll(".image-gallery .left-arrow, .image-gallery .right-arrow"));

const arrowMethods = {
    "left-arrow": (index, total) => {
        if (index - 1 < 0) {
            return total - 1;
        }
        return index - 1;
    },
    "right-arrow": (index, total) => {
        if (index + 1 === total) {
            return 0;
        }
        return index + 1;
    }
}

function goTo(gallery, button) {
    let mainImg = gallery.querySelector(".main-image img"),
        imageStrip = gallery.querySelector(".image-strip"),
        buttons = gallery.querySelectorAll(".image-strip button"),
        indicator = gallery.querySelector(".indicator"),
        url = button.dataset.url;

    mainImg.src = url;
    gallery.dataset.imgIndex = Array.from(buttons).indexOf(button);

    // TODO: UnJQuerify
    $(indicator)
        .animate({
            left: button.offsetLeft
        }, 400);

    log.info(imageStrip.scrollLeft, imageStrip.clientWidth, button.offsetLeft, button.offsetLeft + button.clientWidth);

    const rightOffset = (imageStrip.scrollLeft + imageStrip.clientWidth);
    const buttonRightOffset = (button.offsetLeft + button.clientWidth);

    // Scroll right
    if (rightOffset < buttonRightOffset) {
        imageStrip.scrollTo({
            left: button.offsetLeft + button.clientWidth - imageStrip.clientWidth,
            top: 0,
            behavior: "smooth"
        });
    }
    // Scroll left
    else if (imageStrip.scrollLeft > button.offsetLeft) {
        imageStrip.scrollTo({
            left: button.offsetLeft,
            top: 0,
            behavior: "smooth"
        });
    }
}

galleries.forEach(gallery => {
    gallery.dataset.imgIndex = 0;
});

arrows.forEach(arrow => {
    arrow.addEventListener("click", evt => {
        let gallery = arrow.closest(".image-gallery"),
            // TODO: Undupe query
            buttons = gallery.querySelectorAll(".image-strip button"),
            newIndex = arrowMethods[arrow.className](Number(gallery.dataset.imgIndex), buttons.length);

        goTo(gallery, buttons[newIndex]);
    });
});

allButtons.forEach(button => {
    button.addEventListener("click", evt => {
        let gallery = button.closest(".image-gallery");

        goTo(gallery, button);
    });
});

indicators.forEach(indicator => {
    let btn = indicator.nextElementSibling,
        img = btn.children[0];
    indicator.style.width = `${img.clientWidth}px`;
    indicator.style.height = `${img.clientHeight}px`;
    indicator.style.left = `${btn.offsetLeft}px`;
    indicator.style.top = `${img.offsetTop}px`;
    indicator.style.visibility = "visible";
});